import { render, staticRenderFns } from "./invitedLog.vue?vue&type=template&id=2d1cb616&scoped=true&"
import script from "./invitedLog.vue?vue&type=script&lang=js&"
export * from "./invitedLog.vue?vue&type=script&lang=js&"
import style0 from "./invitedLog.vue?vue&type=style&index=0&id=2d1cb616&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1cb616",
  null
  
)

export default component.exports